import React from 'react';
import { Button } from 'semantic-ui-react';
export default class FileInput extends React.Component {
  render() {
    const {
      onChange,
      onClick,
      filePlaceholder,
      ...rest
    } = this.props;
    const ButtonElement = this.props.Button || Button;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      ref: ref => {
        this.ref = ref;
      },
      type: "file",
      name: "file",
      onChange: onChange,
      style: {
        display: 'none'
      }
    }), /*#__PURE__*/React.createElement(ButtonElement, Object.assign({}, rest, {
      onClick: e => {
        if (onClick) {
          onClick(e);
        }
        if (this.ref && !e.defaultPrevented) {
          this.ref.click();
        }
      }
    })), filePlaceholder && ' ', filePlaceholder !== undefined ? filePlaceholder : 'No File Selected');
  }
}